import { Action, createHook, createStore } from 'react-sweet-state'

export enum TrainingStatusEnum {
    TRAINING = 'TRAINING',
    READY = 'READY',
    LOADING_MODEL = 'LOADING_MODEL',
}

interface RasaStatusState {
    status: TrainingStatusEnum | undefined
}

const rasaStatusInitialState: RasaStatusState = {
    status: undefined,
}

const usersActions = {
    setStatus:
        (status: TrainingStatusEnum): Action<RasaStatusState> =>
        ({ setState }) => {
            setState({
                status,
            })
        },
}

const Store = createStore({
    initialState: rasaStatusInitialState,
    actions: usersActions,
})

export const useRasaStatusStore = createHook(Store)
